import { memo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings, Link2, Sparkles, FileText, Zap, Bot } from 'lucide-react';
import { cn } from '@/lib/utils';

const SettingsSubmenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );

  return (
    <div className="h-full bg-gray-50 dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800">
      <div className="p-2">
        <h2 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2 px-2">
          Settings
        </h2>
        <nav className="space-y-1">
          <button
            onClick={() => handleNavigate('/business-settings')}
            className={`w-full flex items-center gap-2 px-2 py-2 rounded-md text-xs font-medium transition-colors ${
              location.pathname === '/business-settings'
                ? 'bg-primary text-primary-foreground'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            <Settings className="h-3 w-3" />
            <span>Business</span>
          </button>
          <button
            onClick={() => handleNavigate('/connected-accounts')}
            className={`w-full flex items-center gap-2 px-2 py-2 rounded-md text-xs font-medium transition-colors ${
              location.pathname === '/connected-accounts'
                ? 'bg-primary text-primary-foreground'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            <Link2 className="h-3 w-3" />
            <span>Accounts</span>
          </button>
          <button
            onClick={() => handleNavigate('/ai-models')}
            className={`w-full flex items-center gap-2 px-2 py-2 rounded-md text-xs font-medium transition-colors ${
              location.pathname === '/ai-models'
                ? 'bg-primary text-primary-foreground'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            <Sparkles className="h-3 w-3" />
            <span>AI Models</span>
          </button>
          <button
            onClick={() => handleNavigate('/settings/prompts')}
            className={`w-full flex items-center gap-2 px-2 py-2 rounded-md text-xs font-medium transition-colors ${
              location.pathname === '/settings/prompts'
                ? 'bg-primary text-primary-foreground'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            }`}
          >
            <FileText className="h-3 w-3" />
            <span>Prompts</span>
          </button>
          <button
            onClick={() => handleNavigate('/settings/ai-replies')}
            className={cn(
              'w-full flex items-center gap-2 px-2 py-2 rounded-md text-xs font-medium transition-colors',
              location.pathname === '/settings/ai-replies'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            )}
          >
            <Bot className="h-3 w-3" />
            <span>AI Replies</span>
          </button>
          <button
            onClick={() => handleNavigate('/automation')}
            className={cn(
              'w-full flex items-center gap-2 px-2 py-2 rounded-md text-xs font-medium transition-colors',
              location.pathname === '/automation'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            )}
          >
            <Zap className="h-3 w-3" />
            <span>Automation</span>
          </button>
        </nav>
      </div>
    </div>
  );
};

export const SettingsSubmenuMemo = memo(SettingsSubmenu);
